module.exports = __webpack_public_path__ + "static/fonts/342F4F_F_0.98d1b7e.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/342F4F_F_0.woff2
// module id = 114
// module chunks = 3